export const addInitialValues = {
  username: '',
  completeName: '',
  password: '',
  role: 'USER',
};
